export default {
      id: "deco_travaux-usage",
      viewBox: "0 0 170 135",
      url: "../dist/images/" + "sprite.svg#deco_travaux-usage",
      toString: function () {
        return this.url;
      }
    }